// extracted by mini-css-extract-plugin
export var alertIcon = "_sh-0";